<template>
  <div class="form-content">
    <div
      class="form-content__background"
      data-in-out
      data-in-out-animation="fade"
      data-in-out-no-menu
    ></div>

    <form class="form">
      <div class="form-top">
        <div class="form-top__column">
          <span class="form-top__title">Where</span>
        </div>
        <div class="form-top__column">
          <span class="form-top__text">
            Via Borgolecco, 9
            <br>
            36053 Gambellara (Vicenza)
            <br>
            <br>
            <a href="#" target="_blank">View On Google Map</a>
          </span>
        </div>
        <div class="form-top__column">
          <span class="form-top__title">Contact</span>
        </div>
        <div class="form-top__column">
          <span class="form-top__text">
            Tel. 0444 640111
            <br>
            Fax 0444 640204
            <br>
            <br>
            <a href="mailto:info@zonin.it">info@zonin.it</a>
          </span>
        </div>
      </div>

      <div class="form__row" data-in-out data-in-out-animation="slide">
        <div class="form__row-label">
          <span>Name.</span>
        </div>
        <div class="form__row-input">
          <input type="text" placeholder="Insert your name" @focus="inputFocus" ref="name">
        </div>
      </div>
      <div class="form__row" data-in-out data-in-out-animation="slide">
        <div class="form__row-label">
          <span>Surname.</span>
        </div>
        <div class="form__row-input">
          <input type="text" placeholder="Insert your surname" @focus="inputFocus" ref="surname">
        </div>
      </div>
      <div class="form__row" data-in-out data-in-out-animation="slide">
        <div class="form__row-label">
          <span>Email.</span>
        </div>
        <div class="form__row-input">
          <input type="text" placeholder="Insert your email" @focus="inputFocus" ref="email">
        </div>
      </div>
      <div class="form__row" data-in-out data-in-out-animation="slide">
        <div class="form__row-label">
          <span>Request.</span>
        </div>
        <div class="form__row-input">
          <input type="text" placeholder="Insert your request" @focus="inputFocus" ref="message">
        </div>
      </div>

      <div class="form__row last" data-in-out data-in-out-animation="slide">
        <div class="form__row-privacy">
          <div class="form__row-privacy-check">
            <input type="checkbox" id="privacy" ref="privacy">
          </div>
          <div class="form__row-privacy-label">
            <label for="privacy">Accept <a target="_blank" href="http://zonin1821.it/privacy/">Privacy</a></label>
          </div>
        </div>
        <div class="form__row-send" @click="sendForm">
          <label>Send Request.</label>
        </div>
      </div>

      <div class="form__mask" v-if="state !== ''">
        <div class="form__mask-sended" v-if="state === 'sended'">
          <span>Thank You for your request</span>
        </div>
      </div>
    </form>

    <MobileFooter />
  </div>
</template>

<script>
import axios from 'axios';
import engine from '@/scripts/engine';
import scroll from '@/scripts/scroll';
import MobileFooter from '@/components/MobileFooter.vue';

export default {
  name: 'FormContent',

  components: {
    MobileFooter,
  },

  data() {
    return {
      state: '',
    };
  },

  mounted() {
    engine.add(this.scroll, 'form-scroll');
    this.$nextTick(() => scroll.setBoundries(this.$el));
  },

  methods: {
    scroll() {
      scroll.checkIsScrolled(100);
      this.$el.style.transform = `translateY(-${scroll.ref.amount.y}px)`;
    },
    inputFocus(event) {
      const focuses = Array.from(this.$el.querySelectorAll('.focus'));
      focuses.forEach(f => f.classList.remove('focus'));
      event.currentTarget.parentNode.parentNode.classList.add('focus');
    },
    sendForm() {
      const errors = this.$el.querySelectorAll('.error');
      errors.forEach(e => e.classList.remove('error'));
      const data = {
        name: this.$refs.name.value,
        surname: this.$refs.surname.value,
        email: this.$refs.email.value,
        message: this.$refs.message.value,
      };
      let valid = true;
      if (data.name.length < 1) {
        valid = false;
        this.$refs.name.parentNode.classList.add('error');
      }
      if (data.surname.length < 1) {
        valid = false;
        this.$refs.surname.parentNode.classList.add('error');
      }
      if (data.email.indexOf('@') < 1 || data.email.indexOf('.') < 2) {
        valid = false;
        this.$refs.email.parentNode.classList.add('error');
      }
      if (!this.$refs.privacy.checked) {
        valid = false;
        this.$refs.privacy.parentNode.classList.add('error');
      }
      if (valid) {
        this.state = 'sending';
        axios({
          url: 'http://zoninprosecco.com/static/php/sendmail.php',
          method: 'post',
          params: data,
        }).then(() => {
          this.state = 'sended';
        });
      }
    },
  },

  beforeDestroy() {
    engine.remove('form-scroll');
    this.$store.commit('SET_PAGE_SCROLLED', false);
  },
};
</script>

<style lang="scss" scoped>
.form-content {
  padding-top: 100vh;
  padding-top: calc(var(--vh, 1vh) * 100);

  @include mq($until: ipadP) {
    padding-top: 90vh;
    padding-top: calc(var(--vh, 1vh) * 90);
  }

  &__background {
    @extend %full;
    background-color: $color-white;
  }

  .form {
    position: relative;
    margin-left: calc((100vw / 32) * 7);
    margin-right: calc((100vw / 32) * 4);
    padding: 60px 0px;

    @include mq($until: ipadP) {
      margin-left: calc((100vw / 32) * 4);
      padding-top: 0px;
    }

    &-top {
      width: calc((100vw / 32) * 18);
      position: relative;
      color: $color-dark;
      font-size: rem(22px);
      font-size: calc(22px * var(--rw));
      line-height: rem(40px);
      line-height: calc(40px * var(--rw));

      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: calc((100vh / 18) * 3);

      @include mq($until: ipadP) {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-row-gap: calc((100vh / 18) * 2);
      }

      &__title {
        position: relative;

        &::after {
          content: ' ';
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 1px;
          background-color: $color-dark;
        }
      }

      &__text {
        a {
          font-weight: bold;

          @extend %bottom-line;
        }
      }
    }

    &__row {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: calc((100vh / 18) * 1);

      &.last {
        margin-top: calc((100vh / 18) * 2);
      }

      &-label {
        flex-basis: 20%;
        padding: 20px 0px;
        border-bottom: 1px solid #DCDCDC;
        transition: border-color .3s $inOutCubic;
        font-size: rem(22px);
        font-size: $font-size-text;
      }

      &.focus .form__row-label {
        border-color: $color-dark;
      }

      &-input {
        flex-basis: 75%;
        padding: 20px 0px;
        border-bottom: 1px solid #DCDCDC;

        input {
          width: 100%;
          appearance: none;
          border: none;
          color: $color-dark;
          font-family: 'GT Super Display';
          font-size: rem(35px);
          font-size: calc(35px * var(--rw));
          font-weight: 300;

          &:focus {
            outline: none;
          }
        }

        &.error {
          border-color: rgb(170, 11, 11);
        }
      }

      &-send label {
        position: relative;
        display: inline-block;
        @extend %bottom-line;
      }

      &-privacy {
        display: flex;
        align-items: baseline;

        &-check {
          &.error {
            input::before {
              border-color:rgb(170, 11, 11);
            }
          }

          input {
            position: relative;
            appearance: none;
            width: 0px;
            height: 0px;

            @include mq($until: ipadP) {
              transform: translateX(-30px);
            }

            &::before {
              content: ' ';
              position: absolute;
              bottom: -8px;
              left: 0px;
              width: 20px;
              height: 20px;
              border: 1px solid $color-dark;

              @include mq($until: ipadP) {
                width: 17px;
                height: 17px;
                bottom: -4px;
              }
            }

            &::after {
              content: ' ';
              position: absolute;
              left: 7px;
              top: -5px;
              width: 6px;
              height: 6px;
              background-color: $color-dark;
              border-radius: 100%;
              opacity: 0;
              transform: scale(0.4);
              transition: opacity .3s $inOutCubic,
                          transform .3s $inOutCubic;
            }

            &:focus {
              outline: none;
            }

            &:checked::after {
              opacity: 1;
              transform: scale(1);
            }
          }
        }

        &-label {
          font-size: rem(22px);
          font-size: $font-size-text;
          margin-left: 40px;

          a {
            position: relative;
            @extend %bottom-line;
          }

          @include mq($until: ipadP) {
            transform: translateX(-50px);
          }
        }
      }
    }
  }

  .form__mask {
    @extend %full;
    background-color: rgba($color: $color-white, $alpha: 0.8);
    color: $color-dark;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: rem(70px);
    font-size: calc(70px * var(--rw));
    line-height: rem(70px);
    line-height: calc(70px * var(--rw));
    font-weight: 300;
  }
}
</style>
